import {
  type AnyContainerLayout,
  type StackContainerLayout,
} from '@wix/document-services-types'

export function assertStackContainerLayout(
  containerLayout: AnyContainerLayout,
): asserts containerLayout is StackContainerLayout {
  if (containerLayout.type !== 'StackContainerLayout') {
    throw new Error('Not a stack-container layout.')
  }
}
